import {SpecificationType} from "../../definitions/types";

export class SpecificationModel {
    private readonly _delimiter: string;
    private readonly _groupName: string | undefined;
    private readonly _types: string[];
    private readonly _values: string[];

    constructor(public readonly specificationType: SpecificationType) {
        this._delimiter = specificationType.delimiter;
        this._groupName = specificationType.groupName;
        this._types = specificationType.types;
        this._values = specificationType.values;
    }

    /**
     * @method delimiter
     * @description Gets the delimiter for the specification model (e.g. " - " or " x ")
     * @returns {string}
     */
    public get delimiter(): string {
        return this._delimiter;
    }

    /**
     * @method groupName
     * @description Gets the group name for the specification model (e.g. "Dimensions")
     * @returns {string | undefined}
     */
    public get groupName(): string | undefined {
        return this._groupName;
    }

    /**
     * @method types
     * @description Gets the types for the specification model (e.g. "Height", "Width", "Depth")
     * @returns {string[]}
     */
    public get types(): string[] {
        return this._types;
    }

    /**
     * @method values
     * @description Gets the values for the specification model (e.g. "1", "2", "3")
     * @returns {string[]}
     */
    public get values(): string[] {
        return this._values;
    }
}